/**
 * ══ KIỂU CỦA SỔ ĐĂNG KÝ GIAO DIỆN (D03c §3.1) ══════════════════════════════════════════════════
 * Tách riêng khỏi `../ui-tree.ts` để các tệp nhóm (`sales.ts`, `ops.ts`…) import kiểu mà không vòng
 * ngược về bộ tổng hợp.
 */

/** Bốn quyền anh chốt 28/10: Xem · Sửa/Xoá · Thêm/Nhập · Xuất (D03c §3.2). */
export const PERMS = ['view', 'edit', 'create', 'export'] as const
export type Perm = (typeof PERMS)[number]

/**
 * `screen` — một đường dẫn trong `RT_ROUTES` · `tab` — tab hoặc tab con trong màn ·
 * `modal` — hộp thoại có tab riêng (Hộp chi tiết đơn) · `block` — khối cố định trên màn không tab (Cài đặt).
 */
export type UiNodeKind = 'screen' | 'tab' | 'modal' | 'block'

export interface UiNode {
  /** Mã ổn định, tiếng Anh, chấm phân cấp cho dễ đọc — `catalog.accounting.ledgerLock`. Lưu thẳng vào CSDL (`role_grant.node`). */
  id: string
  kind: UiNodeKind
  /** Nút cha. Vắng ⇒ gốc (màn đứng ở sidebar hoặc ẩn khỏi menu). */
  parent?: string
  /** Chỉ `screen`: đường dẫn trong `RT_ROUTES`. */
  path?: string
  /**
   * Chỉ `tab`: giá trị mà màn dùng cho tab này — trong trạng thái của màn và trong tham số `param` của đường dẫn.
   * Vắng ⇒ tab không chọn được bằng đường dẫn (tab trong hộp thoại, tab của màn không đọc tham số).
   */
  tab?: string
  /** Tên tham số đường dẫn màn đọc cho cấp tab này (`tab` · `block` · `sub`). Khai ở nút CHA của nhóm tab. */
  param?: string
  /** Màn: không có mục menu. Tab: không có nút trên thanh tab — chỉ vào được bằng đường dẫn. */
  hidden?: true
  /**
   * Chỉ `tab`, không mang `tab`: NÚT NHÓM — một tab cha mà màn không có trạng thái riêng cho nó (bấm vào là chọn tab
   * con đầu tiên), con của nó được chọn chung bằng biến tab của cấp trên. VD `catalog.accounting` ("📊 Kế toán / AMIS ▸")
   * gom 8 tab kế toán mà `catalog.tsx` giữ cùng một biến với Khách hàng · Nhà cung cấp…
   * Phân quyền vẫn theo cây hai cấp (tắt Xem nhóm là tắt cả 8 tab); chỉ việc chọn tab là đi xuyên qua nó.
   */
  group?: true
  /** Các quyền nút này có. Luôn có `view`. */
  perms: readonly Perm[]
}
